import { useState, useContext, useEffect } from "react";
import { MainContext } from "../../../Context/MainContext";
// import logo from '../../../assets/images/SkuProfi_Iogo_blue_crop.png'
import soLogo from "../../../assets/images/silveronyx-logo.png";
import soLogoText from "../../../assets/images/silveronyx-logo-text.png";
import axios from "axios";
import "./Login.css";

const inputInitialState = {
  usernameOrEmail: "",
  password: "",
};

const regInputInitialState = {
  username: "",
  email: "",
  registerPassword: "",
  registerVerifyPassword: "",
};

const Login = () => {
  const { setUser } = useContext(MainContext);
  // const [showRegister] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [input, setInput] = useState(inputInitialState);
  const [regInput, setRegInput] = useState(regInputInitialState);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  function handleInputChange(e) {
    setInput((old) => ({
      ...old,
      [e.target.name]: e.target.value,
    }));
  }

  function handleRegInputChange(e) {
    setRegInput((old) => ({
      ...old,
      [e.target.name]: e.target.value,
    }));
  }

  function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    axios
      .put("/auth/login", input)
      .then((res) => {
        console.log("USER NOW LOGGED IN");
        console.log(res.data);
        setUser(res.data);
      })
      .catch((err) => {
        console.log("USER NOT LOGGED IN", err);
        console.log(err.response);
        setErrorMessage(() => err.response.data);
        setLoading(false);
      });
  }

  function handleRegister(e) {
    e.preventDefault();
    console.log("hit");
    setLoading(true);
    axios
      .post("/auth/register", regInput)
      .then((res) => {
        console.log("USER NOW REGISTER AND LOGGED IN");
        console.log(res.data);
        setUser(res.data);
      })
      .catch((err) => {
        console.log("USER NOT REGISTERED", err);
        setLoading(false);
      });
  }

  useEffect(() => {
    setErrorMessage(null);
  }, [input, regInput, showRegister]);

  const { usernameOrEmail, password } = input;
  const { username, email, registerPassword, registerVerifyPassword } =
    regInput;

  return (
    <div className="login">
      <section className="login__form">
        <header className="login__form__header">
          {/* <img className='login__form__header__logo' src={logo} alt='logo' /> */}
          <img
            className="login__form__header__logo-so"
            src={soLogo}
            alt="logo"
          />
          <img
            className="login__form__header__logo-so-text"
            src={soLogoText}
            alt="logo text"
          />
        </header>

        <main className="login__form__input-container">
          {showRegister ? (
            <form className="login__form__input-form" onSubmit={handleRegister}>
              <div className="input__container">
                <label className="input__label" htmlFor="username">
                  USERNAME
                </label>
                <input
                  className="input__input"
                  required
                  id="username"
                  value={username}
                  name="username"
                  onChange={handleRegInputChange}
                  placeholder="Username"
                />
              </div>
              <div className="input__container">
                <label className="input__label" htmlFor="email">
                  EMAIL
                </label>
                <input
                  className="input__input"
                  required
                  id="email"
                  value={email}
                  name="email"
                  onChange={handleRegInputChange}
                  placeholder="Email"
                />
              </div>
              <div className="input__container">
                <label className="input__label" htmlFor="password">
                  PASSWORD
                </label>
                <input
                  className="input__input"
                  required
                  id="password"
                  value={registerPassword}
                  name="registerPassword"
                  type="password"
                  onChange={handleRegInputChange}
                  placeholder="Password"
                />
              </div>
              <div className="input__container">
                <label
                  className="input__label"
                  htmlFor="registerVerifyPassword"
                >
                  Verify Password
                </label>
                <input
                  className="input__input"
                  required
                  id="registerVerifyPassword"
                  name="registerVerifyPassword"
                  value={registerVerifyPassword}
                  type="password"
                  onChange={handleRegInputChange}
                  placeholder="Verify Password"
                />
              </div>
              <button className="button" type="submit" disabled={loading}>
                {loading ? "REGISTERING..." : "REGISTER"}
              </button>
              {errorMessage ? (
                <p className="login__form__error">{errorMessage}</p>
              ) : null}
            </form>
          ) : (
            <form className="login__form__input-form" onSubmit={handleLogin}>
              <div className="input__container">
                <label className="input__label" htmlFor="usernameOrEmail">
                  EMAIL
                </label>
                <input
                  className="input__input"
                  required
                  id="usernameOrEmail"
                  value={usernameOrEmail}
                  name="usernameOrEmail"
                  onChange={handleInputChange}
                  placeholder="Email"
                />
              </div>
              <div className="input__container">
                <label className="input__label" htmlFor="password">
                  PASSWORD
                </label>
                <input
                  className="input__input"
                  required
                  id="password"
                  value={password}
                  name="password"
                  type="password"
                  onChange={handleInputChange}
                  placeholder="Password"
                />
              </div>
              <button className="button" type="submit" disabled={loading}>
                {loading ? "LOGGING IN..." : "LOGIN"}
              </button>
              {errorMessage ? (
                <p className="login__form__error">{errorMessage}</p>
              ) : null}
            </form>
          )}
        </main>
      </section>
      <section className="login__background-right"></section>
    </div>
  );
};

export default Login;
